import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteCargoCategory } from '../../../../actions/cargo';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';

class DeleteCargoCategoryButton extends Component {
  state = {
    showWarningModal: false,
  };

  showDeleteModal = () => this.setState({ showWarningModal: true });

  closeDeleteModal = () => this.setState({ showWarningModal: false });

  handleDelete = () => {
    const { cargoCategoryId, dispatchDeleteCargoCategory } = this.props;
    dispatchDeleteCargoCategory({ cargoCategoryId });
  };

  render() {
    const { showWarningModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showWarningModal}
        onClickConfirm={this.handleDelete}
        onClickCancel={this.closeDeleteModal}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.showDeleteModal}>
        Eliminar
      </Button>
    );
    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

DeleteCargoCategoryButton.propTypes = {
  cargoCategoryId: PropTypes.number.isRequired,
  dispatchDeleteCargoCategory: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteCargoCategory: deleteCargoCategory,
};

export default connect(null, mapDispatchToProps)(DeleteCargoCategoryButton);
